
import { Vue, Component } from 'vue-property-decorator';
import Forecast from '@/ui/components/devices/previews/mpc/ConsumptionService/Forecast.vue';
import Chart from '@/ui/components/devices/previews/mpc/ConsumptionService/Chart.vue';

@Component({
  components: {
    Forecast,
    Chart,
  },
})
export default class SettingsCharts extends Vue {
  tab: any = null

  get settingsViewLang() {
    return 'mlModel.ConsumptionService.settingsView.chartTabs';
  }

  get tabs() {
    return [
      {
        title: 'Chart',
        locale: this.settingsViewLang,
        component: 'Chart',
      },
      {
        title: 'Forecast',
        locale: this.settingsViewLang,
        component: 'Forecast',
      },
    ];
  }
}
